import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export { useOpenInCoderLink } from './hooks/useOpenInCoderLink';
export { CoderContributingCard } from './components/CoderContributingCard';
export { OpenInCoderButton } from './components/OpenInCoderButton';

export const coderPlugin = createPlugin({
  id: 'coder',
  routes: {
    root: rootRouteRef,
  },
});

export const CoderPage = coderPlugin.provide(
  createRoutableExtension({
    name: 'CoderPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
